@for(story of stories; track $index){
    @for (section of story?.content?.sections; track $index) {
        @switch(section.component) {
            @case ('popup'){ <app-cms-popup [popup]="section"></app-cms-popup>}
            @case ('bar'){ <app-cms-bar [bar]="section"></app-cms-bar>}
            @default {
                <section [ngClass]="{'mt-[-10px]' : $index === 0}" [id]="!section.anchor ? section._uid : section.anchor">
                    <app-cms-section [section]="section" [index]="$index"></app-cms-section>
                </section>
            }
        }
    }
}
